// extracted by mini-css-extract-plugin
export default {"tasks":"YM-z","task":"ZM-z","svg":"_M-z","text":"aN-z"};